export const DIRECTORY_HOME = "/members";
export const DIRECTORY_BROWSE = `${DIRECTORY_HOME}/browse`;
export const DIRECTORY_RESULTS = `${DIRECTORY_HOME}/results`;

export const linkTo = {
  directory: () => DIRECTORY_HOME,
  browse: () => DIRECTORY_BROWSE,
  results: () => DIRECTORY_RESULTS,
};
